import Vue from 'vue';
import $ from 'webpack-zepto';
const ctx = "@@keepScrollPostion"
var doBind=function(){
    var vnode = this.vm;
    var $li=$(this.el);
    var self=this;
    $li.unbind();
    if(this.expression){
      $li.on("scroll",function(){
        var x = $(this).scrollTop();
        if(!vnode.pos){
          vnode.pos={};
        }
        vnode.pos.x=x;
      });
    }

}

var doRecover=function(){
    var vnode = this.vm;
    if(this.expression){
      if(!$.isEmptyObject(vnode.pos)){
        if(vnode.pos){
          $(this.el).scrollTop(vnode.pos.x);
        }
      }
    }

}
var isAttached = function(element) {
    var currentNode = element.parentNode;
    while (currentNode) {
        if (currentNode.tagName === 'HTML') {
            return true;
        }
        if (currentNode.nodeType === 11) {
            return false;
        }
        currentNode = currentNode.parentNode;
    }
    return false;
};
var getSelfRootVue=function(){

}
export default{
    bind(el,binding,vnode){

        el[ctx]={
            el:el,
            vm:vnode.context,
            expression: binding.value
        }
        var execute=function () {
            doBind.call( el[ctx]);
        }
        var recover=function(){
            doRecover.call(el[ctx]);
        }
        if (el[ctx].vm._isMounted) {
            execute();
            return;
        }
        if(el[ctx].vm._isActivated){
            recover();
            return ;
        }
        el[ctx].vm.$on('hook:mounted', execute);
        el[ctx].vm.$on('hook:activated', recover);
    },
    unbind(){

    }

}
